import { GridApi } from '@ag-grid-enterprise/all-modules';

export enum CompanyDocumentsContextActionTypes {
  SetInitial = 'document/SET_COMPANY_DOCUMENTS_INITIAL_STATE',
  SelectFiles = 'document/SET_SELECTED_FILES_STATE',
}

export type CompanyDocumentsContextActions =
  | { type: CompanyDocumentsContextActionTypes.SetInitial; payload: string }
  | { type: CompanyDocumentsContextActionTypes.SelectFiles; payload: SelectedFilesStateInterface };

export type CompanyDocumentsProps = {
  selectedFiles: SelectedFilesStateInterface;
};

export interface CompanyDocumentsStateInterface extends GridApi {
  selectedFiles: SelectedFilesStateInterface;
}

export type SelectedFilesStateInterface = string[];

export type CompanyDocumentsProviderProps = { children: React.ReactNode };
